import React, { useEffect } from 'react';
import { ConnectButton, useActiveAccount } from "thirdweb/react"; 
import { client } from "../../../../../app/client";
import { useWallet } from '../../../contexts/WalletContext';

const ConnectWalletButton = () => {
  const activeAccount = useActiveAccount();
  const { setAddress } = useWallet();

  useEffect(() => {
    if (activeAccount?.address) {
      setAddress(activeAccount.address);
    }
  }, [activeAccount, setAddress]); // ✅ include setAddress

  return (
    <div>
      <ConnectButton client={client} />
    </div>
  );
};

export default ConnectWalletButton;


